export default function ServiceAreaSection() {
  return (
    <section className="py-20 bg-gradient-to-b from-[#F5F1E8] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#8B4513] mb-4">
            Our Service Area
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Based in Ota City, we provide professional Airbnb management and minpaku support services across Tokyo's key residential and commercial districts.
          </p>
        </div>

        {/* Google Map Embed */}
        <div className="mb-12">
          <div className="rounded-xl overflow-hidden shadow-lg w-full h-[500px] border-2 border-[#B8860B]/20">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207281.2!2d139.6917!3d35.6762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c2ffa206ea3%3A0x30e1c3a4d4b8c252!2sOta%20City%2C%20Tokyo%2C%20Japan!5e0!3m2!1sen!2sjp!4v1700000000000!5m2!1sen!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Tokyo Minpaku Support Service Area - Ota City"
            ></iframe>
          </div>
          
          <div className="mt-6 text-center">
            <p className="text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Based in <strong className="text-[#8B4513]">Ota City</strong>, we support property owners across Tokyo including: <strong className="text-[#8B4513]">Shinagawa, Meguro, Setagaya</strong> and <strong className="text-[#8B4513]">central Tokyo areas</strong>.
            </p>
          </div>
        </div>

        {/* NAP Block - Business Information */}
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 border-2 border-[#B8860B]/20">
          <h3 className="text-2xl md:text-3xl font-bold text-[#8B4513] mb-8 text-center">
            Business Information
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Business Name */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#B8860B] to-[#8B4513] text-white rounded-full mb-4">
                <i className="ri-building-4-line text-2xl"></i>
              </div>
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Business Name
              </h4>
              <p className="text-lg font-bold text-[#8B4513]">
                Tokyo Minpaku Support
              </p>
            </div>

            {/* Location */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#B8860B] to-[#8B4513] text-white rounded-full mb-4">
                <i className="ri-map-pin-2-line text-2xl"></i>
              </div>
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Location
              </h4>
              <p className="text-lg font-bold text-[#8B4513]">
                Ota City, Tokyo, Japan
              </p>
            </div>

            {/* Services */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#B8860B] to-[#8B4513] text-white rounded-full mb-4">
                <i className="ri-service-line text-2xl"></i>
              </div>
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Services
              </h4>
              <p className="text-base font-medium text-gray-700 leading-relaxed">
                Airbnb management, Minpaku registration support, Cleaning management
              </p>
            </div>
          </div>

          {/* Additional Service Areas */}
          <div className="mt-10 pt-8 border-t border-gray-200">
            <h4 className="text-lg font-semibold text-[#8B4513] mb-4 text-center">
              Primary Service Areas
            </h4>
            <div className="flex flex-wrap justify-center gap-3">
              {[
                'Ota City',
                'Shinagawa',
                'Meguro',
                'Setagaya',
                'Shibuya',
                'Minato',
                'Chiyoda',
                'Chuo',
                'Shinjuku',
                'Taito'
              ].map((area) => (
                <span
                  key={area}
                  className="px-4 py-2 bg-gradient-to-r from-[#F5F1E8] to-[#FFF8E7] text-[#8B4513] rounded-full text-sm font-medium border border-[#B8860B]/30 hover:border-[#B8860B] transition-colors cursor-default"
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Schema.org LocalBusiness Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Tokyo Minpaku Support",
            "description": "Professional Airbnb management and minpaku registration support services in Tokyo",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ota City",
              "addressRegion": "Tokyo",
              "addressCountry": "JP"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "35.5617",
              "longitude": "139.7161"
            },
            "areaServed": [
              {
                "@type": "City",
                "name": "Ota City"
              },
              {
                "@type": "City",
                "name": "Shinagawa"
              },
              {
                "@type": "City",
                "name": "Meguro"
              },
              {
                "@type": "City",
                "name": "Setagaya"
              },
              {
                "@type": "City",
                "name": "Tokyo"
              }
            ],
            "serviceType": [
              "Airbnb management",
              "Minpaku registration support",
              "Cleaning management",
              "Short-term rental consulting"
            ],
            "priceRange": "¥¥¥",
            "url": "https://magome-kominka.com"
          })}
        </script>
      </div>
    </section>
  );
}